import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { intlShape } from 'react-intl';

import Footer from '../../Footer';
import Me from '../../Me';
import NavList from './NavList';
import styles from './VerticalNavigation.css';

const VerticalNavigation = ({
  activeItem,
  intl: { locale },
  hasOpenedSidebar,
  hasUser,
  navigationItems,
}) => (
  <nav
    className={classNames(styles.nav, {
      [styles.navVisible]: hasOpenedSidebar,
    })}
  >
    {hasUser && <Me />}
    <NavList
      activeItem={activeItem}
      hasUser={hasUser}
      items={navigationItems.top}
      key={'main'}
      main
      placeholders={4}
    />
    <NavList
      activeItem={activeItem}
      hasUser={hasUser}
      items={navigationItems.other}
      key={'other'}
      placeholders={8}
    />
    <Footer locale={locale} className={styles.footer} collapsible />
  </nav>
);

VerticalNavigation.displayName = 'VerticalNavigation';

VerticalNavigation.propTypes = {
  activeItem: PropTypes.string,
  hasOpenedSidebar: PropTypes.bool.isRequired,
  hasUser: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  navigationItems: PropTypes.shape({
    other: PropTypes.array,
    top: PropTypes.array.isRequired,
  }).isRequired,
};

export default VerticalNavigation;
